import { render, staticRenderFns } from "./EntriesCounter.vue?vue&type=template&id=01447a9c&"
import script from "./EntriesCounter.vue?vue&type=script&lang=js&"
export * from "./EntriesCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports